import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const InfoIcon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 24 24', ...props }}>
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.742 2.742a8.85 8.85 0 1 1 12.516 12.516A8.85 8.85 0 0 1 2.742 2.742ZM9 1.65a7.35 7.35 0 1 0 0 14.7 7.35 7.35 0 0 0 0-14.7Z"
      clipRule="evenodd"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 9.15a.75.75 0 0 1 .75.75v3.6a.75.75 0 0 1-1.5 0V9.9A.75.75 0 0 1 9 9.15ZM9.6 5.904a.75.75 0 0 0-.6-1.2 1.2 1.2 0 0 0 0 2.4.75.75 0 0 0 .6-1.2Z"
      clipRule="evenodd"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.25 5.454a.75.75 0 0 1 .75-.75 1.2 1.2 0 0 1 0 2.4.75.75 0 0 1-.6-1.2.747.747 0 0 1-.15-.45Z"
      clipRule="evenodd"
    />
  </Icon>
)
